<template>
  <div>
    <button @click="toggleScan" class="qr-button primary">
      <i class="material-icons">qr_code_scanner</i>
    </button>

    <div v-show="scanning" class="scanner-overlay">
      <div id="reader" class="scanner"></div>
      <button class="close-button" @click="stopScan">✕</button>
    </div>
  </div>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";

export default {
  name: "QrScanner",
  data() {
    return {
      qrScanner: null,
      scanning: false,
    };
  },
  methods: {
    toggleScan() {
      if (this.scanning) {
        this.stopScan();
      } else {
        this.startScan();
      }
    },
    startScan() {
      this.scanning = true;
      this.$nextTick(() => {
        const qrRegionId = "reader";
        this.qrScanner = new Html5Qrcode(qrRegionId);
        const config = { fps: 10, qrbox: 250 };

        this.qrScanner
          .start(
            { facingMode: "environment" },
            config,
            (decodedText) => {
              this.$emit("scanned", decodedText);
              this.stopScan();
            },
            (error) => {
              console.log(`Error de escaneo: ${error}`);
            }
          )
          .catch((err) => {
            console.log("No se pudo iniciar el escáner:", err);
            this.stopScan();
          });
      });
    },
    stopScan() {
      if (this.qrScanner) {
        this.qrScanner
          .stop()
          .then(() => {
            this.qrScanner.clear();
            this.qrScanner = null;
            this.scanning = false;
          })
          .catch((err) => {
            console.log("Error al detener el escáner:", err);
            this.scanning = false;
          });
      } else {
        this.scanning = false;
      }
    },
  },
  beforeDestroy() {
    this.stopScan();
  },
};
</script>

<style scoped>
.qr-button {
  background-color: #9b9b9b;
  color: white;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.qr-button:hover {
  background-color: #5f5f5f;
}

.scanner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.scanner {
  width: 320px;
  min-height: 320px;
  background: white;
  padding: 10px;
  border-radius: 8px;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #000000;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 18px;
  cursor: pointer;
}

.close-button:hover {
  background: #d32f2f;
}
</style>
